import { useQuery } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { ChannelResponse } from '../types/backend';

const getChannel = async (channelId: number): Promise<ChannelResponse> => {
  return axios.get(`${MESSAGING_API_BASE}/channels/${channelId}`);
};

type QueryFnType = typeof getChannel;

type UseChannelOptions = {
  channelId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useChannel = ({ channelId, config }: UseChannelOptions) => {
  return useQuery({
    queryKey: [...messagingQueryKeys.channel(channelId)],
    queryFn: () => getChannel(channelId),
    staleTime: Infinity,
    enabled: channelId > 0,
    ...config,
  });
};
